Object.defineProperty(exports, '__esModule', { value: true });

var MARK = 'v1';

exports.MARK = MARK;
//# sourceMappingURL=base.js.map
